module.exports = __webpack_public_path__ + "img/module-appointments.954386a6.svg";